import React from "react";
import { Grid, Header, Container } from "semantic-ui-react";
import Icon from "../../components/Icon/";

import { Switch, Route } from "react-router-dom";

import LoadingGate from "../../components/LoadingGate";

import ReimbursementView from "./ReimbursementView";
import SubmitterView from "./SubmitterView";
import SubmitterSignupView from "./SubmitterSignupView";

import {
  loadReimbursement,
  isReimbursementLoading,
  getReimbursementError
} from "../../actions/unauthenticated/reimbursement";
import {
  loadSubmitter,
  isSubmitterLoading,
  getSubmitterError
} from "../../actions/unauthenticated/submitter";
import {
  loadOrganization,
  isOrganizationLoading,
  getOrganizationError
} from "../../actions/unauthenticated/organization";

const WrapComponent = props => {
  return (
    <Grid textAlign="center">
      <style>{`
      .unauthedHeader {
        padding: 3em 0 2.5em 0 !important;
        background: #4267bb !important; /* Old browsers */
        background: -moz-linear-gradient(45deg, #4267bb 0%, #17357a 100%) !important; /* FF3.6-15 */
        background: -webkit-linear-gradient(45deg, #4267bb 0%,#17357a 100%) !important; /* Chrome10-25,Safari5.1-6 */
        background: linear-gradient(45deg, #4267bb 0%,#17357a 100%) !important;  W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ 
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#4267bb', endColorstr='#17357a',GradientType=1 ) !important; /* IE6-9 fallback on horizontal gradient */
      }
    `}</style>
      <Grid.Row>
        <Grid.Column className="unauthedHeader" width="16">
          <Header inverted as="h1" style={{ fontSize: "3em" }}>
            <Icon icon="spout" /> Spout
          </Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Container text>{props.children}</Container>
      </Grid.Row>
    </Grid>
  );
};

const ReimbursementLoader = props => {
  const { uuid, modifyKey } = props.match.params;
  return (
    <LoadingGate
      loadedComponent={() => (
        <WrapComponent>
          <ReimbursementView />
        </WrapComponent>
      )}
      loadAction={() => loadReimbursement(uuid, modifyKey)}
      isLoading={isReimbursementLoading}
      getError={getReimbursementError}
    />
  );
};

const SubmitterLoader = props => {
  const { uuid, modifyKey } = props.match.params;
  return (
    <LoadingGate
      loadedComponent={() => (
        <WrapComponent>
          <SubmitterView />
        </WrapComponent>
      )}
      loadAction={() => loadSubmitter(uuid, modifyKey)}
      isLoading={isSubmitterLoading}
      getError={getSubmitterError}
    />
  );
};

const SubmitterSignupLoader = props => {
  const { uuid, modifyKey } = props.match.params;
  return (
    <LoadingGate
      loadedComponent={() => (
        <WrapComponent>
          <SubmitterSignupView />
        </WrapComponent>
      )}
      loadAction={() => loadOrganization(uuid, modifyKey)}
      isLoading={isOrganizationLoading}
      getError={getOrganizationError}
    />
  );
};

const NotFoundComponent = props => (
  <Grid textAlign="center" style={{ height: "100vh" }} verticalAlign="middle">
    <Grid.Column>
      <Header as="h1">404 - page not found.</Header>
    </Grid.Column>
  </Grid>
);

export default () => {
  return (
    <Switch>
      <Route
        path="/_/reimbursement/:uuid/:modifyKey"
        component={ReimbursementLoader}
      />
      <Route path="/_/submitter/:uuid/:modifyKey" component={SubmitterLoader} />
      <Route
        path="/_/submitter_signup/:uuid/:modifyKey"
        component={SubmitterSignupLoader}
      />
      <Route component={NotFoundComponent} />
    </Switch>
  );
};



// WEBPACK FOOTER //
// ./frontend/src/views/unauthenticated/UnauthenticatedAppView.js